import { Column } from "./dataTable.common";
import React from "react";
import { safeextend } from "../helpers";
import _ from "lodash";

export interface FooterRowProps<T> {
  groupLevel: number;
  colSpan: number;
  elements: T[];
  allElements: T[];
  columns: Column<T>[];
  styleSelector?: (item: T | null) => React.CSSProperties | undefined;
}

export class FooterRow extends React.PureComponent<FooterRowProps<any>> {
  render() {
    const elementsToUse =
      this.props.groupLevel === -1
        ? this.props.allElements
        : this.props.elements;
    const tds = this.props.columns.map((column, i) => {
      const footerInfo = column.getValueForFooter();
      return (
        <td className={column.props.footerClassName} key={i}>
          {footerInfo && footerInfo(elementsToUse)}
        </td>
      );
    });

    const style = safeextend(
      {
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #bbbbbb",
        borderTop: "2px solid #bbbbbb"
      },
      this.props.styleSelector && this.props.styleSelector(null)
    );
    if (
      this.props.elements.length === 0 ||
      !_.find(this.props.columns, x => x.getValueForFooter() !== undefined)
    ) {
      return <tr style={style} />;
    }
    return <tr style={style}>{tds}</tr>;
  }
}
